module.exports = __webpack_public_path__ + "static/media/iv_down_arrow.46907393.svg";